/** @param {unknown} status */
export const normalizeDcfStatus = (status) => String(status ?? '').trim().toLowerCase();

/** @param {unknown} status */
export const isDcfOpen = (status) => normalizeDcfStatus(status) === 'open';

/** @param {unknown} status */
export const isDcfResolved = (status) => normalizeDcfStatus(status) === 'resolved';

/** @param {unknown} status */
export const isDcfClosed = (status) => normalizeDcfStatus(status) === 'closed';
